import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const ContentContext = createContext(null);

const STORAGE_KEY = 'rotama.lang';

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem(STORAGE_KEY) || 'en';
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/content');
      setContent(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const switchLang = useCallback((next) => {
    setLang(next);
    if (typeof window !== 'undefined') localStorage.setItem(STORAGE_KEY, next);
  }, []);

  const t = content ? content[lang] : null;

  const saveContent = async (payload) => {
    await api.put('/content', payload);
    setContent(payload);
  };

  return (
    <ContentContext.Provider value={{ content, setContent, t, lang, switchLang, loading, refresh: load, saveContent }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error('useContent must be used within ContentProvider');
  return ctx;
}
